import React, { useState } from 'react';
import { ClickAwayListener, CircularProgress } from '@material-ui/core';
import { ArrowUpIcon } from '~/assets/svgIcons';
import { ChannelTypeEnum } from '~/enums/conversations';
import {
  ChannelIcon,
  // Divider,
  DropdownArrow,
  DropdownItem,
  DropdownItemIcon,
  DropdownMenu,
  DropdownTrigger,
  SendAction,
  Wrapper,
} from './styles';

type ChannelOption = {
  type: ChannelTypeEnum;
  label: string;
  icon: string;
  color: string;
};

type SendChannelButtonProps = {
  onSend: () => void;
  onChannelChange: (channel: ChannelTypeEnum) => void;
  channelOptions: ChannelOption[];
  // eslint-disable-next-line
  disabled?: boolean;
  // eslint-disable-next-line
  isLoading?: boolean;
};

export default function SendChannelButton({
  onSend,
  onChannelChange,
  channelOptions,
  disabled = false,
  isLoading = false,
}: SendChannelButtonProps) {
  const [open, setOpen] = useState(false);

  const activeOption = channelOptions[0];

  const handleSend = () => {
    if (disabled || isLoading) return;
    onSend();
  };

  const handleChannelChange = (channel: ChannelTypeEnum) => {
    onChannelChange(channel);
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Wrapper disabled={disabled}>
        <SendAction
          type="button"
          onClick={handleSend}
          disabled={disabled || isLoading}
          data-test-id="send-channel-button">
          {isLoading ? (
            <CircularProgress
              color="inherit"
              style={{ width: 14, height: 14 }}
            />
          ) : (
            <ChannelIcon
              src={activeOption.icon}
              disabled={disabled}
              data-test-id={`active-channel-${activeOption.label?.toLowerCase()}`}
            />
          )}
          <span>Send</span>
        </SendAction>

        {/* <Divider backgroundColor={activeOption.color} /> */}

        <DropdownTrigger
          type="button"
          data-test-id="choose-channel-dropdown-trigger"
          onClick={() => setOpen(prev => !prev)}
          disabled={channelOptions.length <= 1}
          {...(channelOptions.length <= 1 && {
            disabled: true,
            title: 'No other channels available',
          })}>
          <DropdownArrow src={ArrowUpIcon} open={open} />
        </DropdownTrigger>

        {open && (
          <DropdownMenu>
            {channelOptions.map(option => (
              <DropdownItem
                key={option.type}
                role="button"
                data-test-id={`channel-option-${option.label.toLowerCase()}`}
                onClick={() => handleChannelChange(option.type)}>
                <DropdownItemIcon src={option.icon} />
                <span
                  style={{
                    fontWeight:
                      activeOption.type === option.type ? 'bold' : 'normal',
                  }}>
                  {option.label}
                </span>
              </DropdownItem>
            ))}
          </DropdownMenu>
        )}
      </Wrapper>
    </ClickAwayListener>
  );
}
